import { Button, SemanticCOLORS, SemanticFLOATS } from "semantic-ui-react";
import { ReactElement } from "react";

export const ButtonComponent = (props: { props: ButtonComponentProps }) => {
  return (
    <Button
      className={`flex`}
      onClick={() => {
        props.props.getOnClickFunction()();
      }}
      disabled={props.props.getDisabled()}
      color={props.props.getColor()}
      floated={props.props.getFloated()}
      style={{ ...props.props.style }}
      link={props.props.link}
      basic={props.props.basic}
      primary={props.props.getPrimary()}
    >
      {props.props.getLabel().getValue()}
    </Button>
  );
};

export class ButtonLabelComponentProps {
  text?: string;
  postIcon?: ReactElement<any, any>;
  preIcon?: ReactElement<any, any>;

  constructor(input: {
    text?: string;
    postIcon?: ReactElement<any, any>;
    preIcon?: ReactElement<any, any>;
  }) {
    this.text = input.text;
    this.postIcon = input.postIcon;
    this.preIcon = input.preIcon;
  }

  getValue(): ReactElement {
    return (
      <>
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          {this.preIcon}
          <span>{this.text}</span>
          {this.postIcon}
        </span>
      </>
    );
  }
}

export class ButtonComponentProps {
  label: ButtonLabelComponentProps;
  private primary: boolean;
  private onClickFunction: () => void;
  private positive: boolean;
  private disabled: boolean;
  private page: string;
  private color: SemanticCOLORS | undefined;
  private floated: SemanticFLOATS | undefined;
  link?: boolean;
  style?: any;
  basic?: boolean;

  constructor(input: {
    label: ButtonLabelComponentProps;
    primary?: boolean;
    onClickFunction: () => void;
    positive?: boolean;
    disabled?: boolean;
    page: string;
    color?: SemanticCOLORS;
    floated?: SemanticFLOATS;
    style?: any;
    link?: boolean;
    basic?: boolean;
  }) {
    this.label = input.label;
    this.primary = false;
    if (input.primary) {
      this.primary = true;
    }
    this.positive = false;
    if (input.positive) {
      this.positive = true;
    }
    this.onClickFunction = input.onClickFunction;
    this.disabled = false;
    if (input.disabled) {
      this.disabled = true;
    }
    this.page = input.page;
    this.color = input.color;
    this.floated = input.floated;
    this.style = input.style;
    this.link = input.link;
    this.basic = input.basic;
  }

  getPage(): string {
    return this.page;
  }

  getLabel(): ButtonLabelComponentProps {
    return this.label;
  }

  getPrimary(): boolean {
    return this.primary;
  }

  getOnClickFunction(): () => void {
    return this.onClickFunction;
  }

  getPositive(): boolean {
    return this.positive;
  }

  getDisabled(): boolean {
    return this.disabled;
  }

  getColor() {
    return this.color;
  }

  getFloated() {
    return this.floated;
  }

  copyPropsButAddToOnClick(additionalStep: () => void): ButtonComponentProps {
    return new ButtonComponentProps({
      label: this.label,
      onClickFunction: () => {
        this.onClickFunction();
        additionalStep();
      },
      page: this.page,
      primary: this.primary,
      color: this.color,
      positive: this.positive,
      disabled: this.disabled,
      floated: this.floated,
    });
  }
}
